<template>
    <div class="my-8 flex justify-center">
        <div class="w-[150px] h-[4px] bg-white rounded-full"></div>
    </div>
</template>
